export default __webpack_public_path__ + "static/media/f-1.4e374ede.jpg";